import { IHttpClient } from '@wix/http-client';
import {
  ITemplateRepository,
  LoadTemplatesParams,
  SearchTemplatesParams,
} from './proto/ITemplateRepository';
import { queryTemplates } from '@wix/ambassador-funnel-templates-gallery-v2-template/http';

import { mapAmbassadorTemplate, Template } from '../entities/template';

export class HttpTemplateRepository implements ITemplateRepository {
  constructor(private httpClient: IHttpClient) {}

  async loadTemplates(params: LoadTemplatesParams) {
    const { categoryId, language, limit, offset } = params;

    const templatesResponse = await this.httpClient.request(
      queryTemplates({
        space: 'studio',
        categoryIds: [categoryId],
        language,
        limit,
        offset,
      }),
    );

    return {
      templates: (templatesResponse.data.templates || []).map<Template>(
        mapAmbassadorTemplate,
      ),
      total: templatesResponse.data.pagingMetadata?.total || 0,
      offset,
    };
  }

  async searchTemplates({
    language,
    limit,
    offset,
    query,
  }: SearchTemplatesParams) {
    const templatesResponse = await this.httpClient.request(
      queryTemplates({
        space: 'studio',
        search: query.slice(0, 100), // validation does not allow more than 100 chars
        language,
        limit,
        offset,
      }),
    );

    const ambassadorTemplates = (templatesResponse.data.templates || []).filter(
      (template) => !!template,
    );

    return {
      templates: ambassadorTemplates.map<Template>(mapAmbassadorTemplate),
      total: templatesResponse.data.pagingMetadata?.total || 0,
      offset,
    };
  }
}
